export enum IssueType {
    Issue = 1,
    Conflict = 2
}

export enum IssuesCodes {
    increaseTeamMemberEngagement = 'IS_A_000',
    teamMemberDriver = 'IS_H_010',
    selfDriver = 'IS_I_011',
    selfEmergancyRecharge = 'IS_K_012',
    teamMemberRecharge = 'IS_L_013'

}